import { useAppMetaContent } from '../../../../../../state-management/providers/AppMetaContentProvider'
import { GROUPED_STATIC_TEXT_ROLE } from '../../../../../ui-components/NameValueTableRow'

export const BrokeTrustedAdvisorySection = () => {
  const { getInvestorsDisplay, getAumTrackedDisplay, getEliteMembersDisplay } = useAppMetaContent()

  return (
    <div className='px-5 pt-12 pb-56'>
      <h2
        role={GROUPED_STATIC_TEXT_ROLE}
        aria-label="We are India's trusted mutual fund advisory app."
        className='text-[20px] font-medium mb-6 m-0'
      >
        <span aria-hidden='true'>
          <span className='text-black'>We are India's </span>
          <span className='text-blue30'>trusted mutual fund advisory app.</span>
        </span>
      </h2>
      <div
        role={GROUPED_STATIC_TEXT_ROLE}
        aria-label='in a short span of 12 months, we now have:'
        className='text-[12px] text-[#6A6E6E]'
      >
        <span aria-hidden='true'>in a short span of 12 months, we now have:</span>
      </div>
      <ul className='flex items-center my-6 bg-[#EBF2F2] rounded-lg list-none m-0 p-0'>
        <li className='w-[2px] h-12 mr-4 bg-[#D1D6D6] list-none' aria-hidden='true' />
        <li
          role={GROUPED_STATIC_TEXT_ROLE}
          className='flex flex-col mr-6 list-none'
          aria-label={`${getInvestorsDisplay('long') ?? ''} Investors`}
        >
          <div className='text-[14px] font-medium text-[#232323] mb-1' aria-hidden='true'>
            {getInvestorsDisplay('long')}
          </div>
          <div className='text-[12px] font-normal text-[#6A6E6E]' aria-hidden='true'>
            Investors
          </div>
        </li>
        <li className='w-[2px] h-12 mr-4 bg-[#D1D6D6] list-none' aria-hidden='true' />
        <li
          role={GROUPED_STATIC_TEXT_ROLE}
          className='flex flex-col mr-6 list-none'
          aria-label={`${getAumTrackedDisplay('long') ?? ''} AUM tracked`}
        >
          <div className='text-[14px] font-medium text-[#232323] mb-1' aria-hidden='true'>
            {getAumTrackedDisplay('long')}
          </div>
          <div className='text-[12px] font-normal text-[#6A6E6E]' aria-hidden='true'>
            AUM tracked
          </div>
        </li>
        <li className='w-[2px] h-12 mr-4 bg-[#D1D6D6] list-none' aria-hidden='true' />
        <li
          role={GROUPED_STATIC_TEXT_ROLE}
          className='flex flex-col list-none'
          aria-label={`${getEliteMembersDisplay('long') ?? ''} Elite members`}
        >
          <div className='text-[14px] font-medium text-[#232323] mb-1' aria-hidden='true'>
            {getEliteMembersDisplay('long')}
          </div>
          <div className='text-[12px] font-normal text-[#6A6E6E]' aria-hidden='true'>
            Elite members
          </div>
        </li>
      </ul>
      <div
        role={GROUPED_STATIC_TEXT_ROLE}
        aria-label="PowerUp is the fastest-growing mutual fund advisory platform in India. We are backed by Accel, Blume, Kae Capital, and some of the world's best investors. We built Elite so you can get the same edge the top 1% rely on, and we can't wait for you to experience it."
        className='mb-8 text-[#6A6E6E] text-[12px]'
      >
        <div aria-hidden='true'>
          PowerUp is the fastest-growing mutual fund advisory platform in India. We are backed by Accel, Blume, Kae
          Capital, and some of the world's best investors.
          <br />
          <br />
          <span className='font-[500]'>
            We built Elite so you can get the same edge the top 1% rely on, and we can't wait for you to experience it.
          </span>
        </div>
      </div>
      <div aria-hidden='true'>
        <svg xmlns='http://www.w3.org/2000/svg' width='101' height='13' viewBox='0 0 101 13' fill='none'>
          <path
            d='M8.91797 6.818C8.91797 4.786 10.5274 3.67969 12.7923 3.67969C15.0684 3.67969 16.6664 4.78599 16.6664 6.818C16.6664 8.86121 15.057 9.96753 12.7923 9.96753C10.539 9.96753 8.91797 8.86121 8.91797 6.818ZM12.7693 8.39837C13.8613 8.39837 14.6086 7.8001 14.6086 6.818C14.6086 5.8359 13.8613 5.23764 12.7693 5.23764C11.7115 5.23764 10.9757 5.8359 10.9757 6.818C10.9757 7.8001 11.7115 8.39837 12.7693 8.39837Z'
            fill='#899098'
            fillOpacity='0.5'
          />
          <path
            d='M16.8398 3.91406H19.0241L20.1968 7.95547H20.3002L21.4727 3.91406H24.002L25.1745 7.95547H25.278L26.4506 3.91406H28.6349L26.715 9.75026H23.8985L22.7949 5.67504H22.6798L21.5762 9.75026H18.7597L16.8398 3.91406Z'
            fill='#899098'
            fillOpacity='0.5'
          />
          <path
            d='M28.8125 6.84042C28.8125 4.7972 30.307 3.67969 32.5719 3.67969C34.6641 3.67969 36.3425 4.56018 36.3425 6.7728V7.23565H30.8818C31.0198 8.04834 31.7785 8.42097 32.7442 8.42097C33.48 8.42097 33.8813 8.33201 34.3083 7.94256L36.3541 7.92412C35.7907 9.45947 34.4227 9.97873 32.7558 9.97873C30.3761 9.97873 28.8125 8.87242 28.8125 6.84042ZM34.2043 6.13359C34.2043 5.65734 33.6757 5.06822 32.6982 5.06822C31.6096 5.06822 31.1149 5.54304 31.0083 6.13359H34.2043Z'
            fill='#899098'
            fillOpacity='0.5'
          />
          <path
            d='M48.5409 1.64844V6.66055C48.5409 7.81206 47.7821 8.1507 46.5406 8.1507C45.2991 8.1507 44.5403 7.81206 44.5403 6.66055V1.64844H42.3789V6.93157C42.3789 9.1328 44.092 9.97949 46.5406 9.97949C48.9893 9.97949 50.7021 9.1328 50.7021 6.93157V1.64844H48.5409Z'
            fill='#899098'
            fillOpacity='0.5'
          />
          <path
            d='M59.225 3.28808C60.1497 3.28808 60.8993 2.55202 60.8993 1.64404C60.8993 0.736066 60.1497 0 59.225 0C58.3004 0 57.5508 0.736066 57.5508 1.64404C57.5508 2.55202 58.3004 3.28808 59.225 3.28808Z'
            fill='#899098'
            fillOpacity='0.5'
          />
          <path
            d='M39.6 4.23582L38.6814 4.94161V3.68367L37.1602 3.67969V9.75292H39.1605V7.86773C39.1605 6.23095 39.9306 5.33906 41.4366 5.33906V3.6909L41.2591 3.69043C40.8282 3.68931 40.4043 3.78605 40.02 3.97141C39.8705 4.04355 39.7312 4.13498 39.6 4.23582Z'
            fill='#899098'
            fillOpacity='0.5'
          />
          <path
            d='M55.8493 3.67969H55.7392C55.0109 3.67969 54.3054 3.92894 53.744 4.38457L53.596 4.50463V3.6797H51.6992V12.0107H53.7684V9.17725C54.1709 9.6627 54.9525 9.96754 55.8493 9.96754C57.7231 9.96754 59.2291 8.86122 59.2291 6.80662C59.2291 4.78601 57.7231 3.67969 55.8493 3.67969ZM55.378 8.31936C54.2858 8.31936 53.596 7.73231 53.596 6.80662C53.596 5.90353 54.2858 5.32786 55.378 5.32786C56.47 5.32786 57.1597 5.90353 57.1597 6.80662C57.1597 7.73231 56.47 8.31936 55.378 8.31936Z'
            fill='#899098'
            fillOpacity='0.5'
          />
          <path
            d='M5.01238 1.64844H0V9.75366H2.44867V6.89291C2.44867 6.68014 2.34721 6.47966 2.17452 6.35116L1.43062 7.01058H5.06981C7.63339 7.01058 8.54162 5.87046 8.54162 4.35771C8.54162 2.85636 7.65639 1.64844 5.01238 1.64844ZM5.03539 5.2722H2.16125V3.387H4.97777C5.35723 3.387 6.38043 3.38701 6.38043 4.34651C6.38043 4.92217 6.01252 5.2722 5.03539 5.2722Z'
            fill='#899098'
            fillOpacity='0.5'
          />
          <path
            d='M95.4718 12.5063C94.997 12.5063 94.6139 12.4355 94.3224 12.2938V10.9568C94.364 10.9818 94.4889 11.011 94.6972 11.0443C94.9054 11.0859 95.1011 11.1068 95.2844 11.1068C95.5592 11.1068 95.8008 11.0276 96.009 10.8694C96.2256 10.7111 96.3713 10.4987 96.4463 10.2321L96.4963 10.0572L93.7227 3.85938H95.4468L96.7836 7.08322C96.9336 7.44975 97.046 7.80379 97.121 8.14534C97.2043 8.47855 97.2459 8.67431 97.2459 8.73263H97.3334L97.3583 8.64516C97.45 8.12868 97.6041 7.6122 97.8206 7.09571L99.2074 3.85938H100.957L97.6332 11.0068C97.4083 11.4983 97.1126 11.869 96.7461 12.1189C96.3797 12.3772 95.9549 12.5063 95.4718 12.5063Z'
            fill='#899098'
            fillOpacity='0.5'
          />
          <path
            d='M87.2734 6.95509C87.2734 6.28866 87.4109 5.71387 87.6857 5.23071C87.9689 4.73922 88.3687 4.36435 88.8851 4.10611C89.4015 3.84787 90.0012 3.71875 90.6842 3.71875C91.4089 3.71875 92.0169 3.86037 92.5083 4.1436C92.9998 4.42683 93.3662 4.81419 93.6078 5.30568C93.8493 5.78884 93.9701 6.33031 93.9701 6.9301C93.9701 7.07171 93.9618 7.24249 93.9451 7.44241H88.098L88.9476 6.75516C88.8393 7.4799 88.9393 8.0297 89.2475 8.40457C89.564 8.7711 90.0387 8.95437 90.6717 8.95437C91.0799 8.95437 91.4172 8.87523 91.6837 8.71696C91.9586 8.55868 92.1502 8.35875 92.2585 8.11717H93.9076C93.7577 8.76694 93.4121 9.27925 92.8707 9.65412C92.3293 10.029 91.6088 10.2164 90.7092 10.2164C89.6348 10.2164 88.7935 9.93735 88.1855 9.37922C87.5775 8.81276 87.2734 8.00471 87.2734 6.95509ZM88.9101 6.98008L88.098 6.39279H92.3834C92.3834 5.96794 92.2376 5.61807 91.9461 5.34317C91.6546 5.05994 91.234 4.91832 90.6842 4.91832C90.0512 4.91832 89.5806 5.10992 89.2724 5.49311C88.9643 5.87631 88.8435 6.37196 88.9101 6.98008Z'
            fill='#899098'
            fillOpacity='0.5'
          />
          <path
            d='M80.3906 10.0665V3.8687H81.9898L81.74 5.2557H81.8649C82.0648 4.85584 82.3688 4.5018 82.7769 4.19358C83.1934 3.87703 83.6973 3.71875 84.2887 3.71875C84.955 3.71875 85.5006 3.93534 85.9254 4.36852C86.3585 4.80169 86.575 5.43064 86.575 6.25534V10.0665H84.9758V6.54274C84.9758 6.08457 84.8509 5.73886 84.601 5.50561C84.3595 5.26403 84.0305 5.14324 83.614 5.14324C83.2975 5.14324 83.0185 5.21405 82.7769 5.35566C82.5354 5.49728 82.3438 5.71387 82.2022 6.00543C82.0606 6.29699 81.9898 6.66353 81.9898 7.10503V10.0665H80.3906Z'
            fill='#899098'
            fillOpacity='0.5'
          />
          <path
            d='M76.4694 10.2164C75.7864 10.2164 75.1867 10.0831 74.6703 9.81656C74.1539 9.54166 73.7541 9.15846 73.4709 8.66697C73.196 8.17548 73.0586 7.60902 73.0586 6.96758C73.0586 6.31782 73.196 5.74719 73.4709 5.2557C73.7541 4.76421 74.1497 4.38518 74.6578 4.11861C75.1742 3.85204 75.7781 3.71875 76.4694 3.71875C77.1607 3.71875 77.7604 3.85204 78.2685 4.11861C78.7849 4.38518 79.1805 4.76421 79.4554 5.2557C79.7386 5.74719 79.8802 6.31782 79.8802 6.96758C79.8802 7.60902 79.7386 8.17548 79.4554 8.66697C79.1805 9.15846 78.7849 9.54166 78.2685 9.81656C77.7521 10.0831 77.1524 10.2164 76.4694 10.2164ZM76.4694 8.91688C77.0275 8.91688 77.4689 8.74195 77.7937 8.39207C78.1186 8.03387 78.281 7.55904 78.281 6.96758C78.281 6.37613 78.1186 5.9013 77.7937 5.54309C77.4689 5.18489 77.0275 5.00579 76.4694 5.00579C75.9113 5.00579 75.4699 5.18489 75.1451 5.54309C74.8202 5.9013 74.6578 6.37613 74.6578 6.96758C74.6578 7.55904 74.8202 8.03387 75.1451 8.39207C75.4699 8.74195 75.9113 8.91688 76.4694 8.91688Z'
            fill='#899098'
            fillOpacity='0.5'
          />
          <path
            d='M63.4453 10.0766V1.36719H65.0945L67.5183 7.02766C67.7182 7.49415 67.8806 8.0148 68.0055 8.58959L68.018 8.66457H68.1055L68.118 8.58959C68.2096 8.03146 68.3554 7.50665 68.5553 7.01516L70.7917 1.36719H72.4408V10.0766H70.8416V6.29042C70.8416 5.73229 70.875 5.20748 70.9416 4.71599L70.9541 4.55354L70.8666 4.54105C70.8666 4.57437 70.8166 4.76597 70.7167 5.11584C70.6167 5.46572 70.496 5.82809 70.3544 6.20295L68.8551 10.0516H67.1934L65.5693 6.19046C65.4443 5.89889 65.336 5.6115 65.2444 5.32827C65.1528 5.0367 65.082 4.80762 65.032 4.64101C65.0237 4.59936 65.0154 4.56604 65.007 4.54105L64.9196 4.56604C65.0029 5.11584 65.0445 5.69064 65.0445 6.29042V10.0766H63.4453Z'
            fill='#899098'
            fillOpacity='0.5'
          />
        </svg>
      </div>
    </div>
  )
}
